module.exports = __webpack_public_path__ + "img/news6-1.2472f79e.png";